export const channel = {
  'ChaCha美瞳': 1,
  '屈臣氏': 2,
  '康是美': 3,
  '寶雅': 4,
  '年青人眼鏡': 5,
  '獨立眼鏡行': 6,
  '家樂福': 7
}